module.exports = __webpack_public_path__ + "static/media/ju3.51bb8de6.png";